import { DateTime } from 'luxon';

/**
 * Given a countdown config object and an HTML element,
 * returns a function which when updated will render a countdown
 * to the page. If real-time updates are desired, use setInterval
 * or requestAnimationFrame to schedule UI updates.
 * 
 * @param {object} countdown - countdown config
 * @param {HTMLElement} element - HTML element to render counter into.
 * @returns {function} render function
 */
const makeRenderCountdown = ({
   iso,
   target,
   metrics,
   showDecimals,
   padDigits,
   metricValueClass = 'metric-value',
   metricLabelClass = 'metric-label',
   wrapElementType = 'span',
}, element) => {
   let dateTarget;
   if (iso){
      dateTarget = DateTime.fromISO(iso);
   }
   else if (target) {
      // format used in legacy countdown modules
      var dateAndTime = target.split(' ');
      var dateBlocks = dateAndTime[0].split('-');
      var timeBlocks = dateAndTime[1].split(':');
      var blocks = dateBlocks.concat(timeBlocks).map(x => parseInt(x, 10));
      dateTarget = new Date(
         blocks[0],
         blocks[1] - 1,
         blocks[2],
         blocks[3],
         blocks[4],
      );
   }
   const metricTypes = metrics.map(x => x.type);
   const metricData = metrics.map(m => ({
      ...m,
      element: element.querySelector(`.${m.type}`),
   }));
   const lastValues = {};
   return () => {
      const dateNow = DateTime.now();
      const timeRemaining = dateTarget.diff(dateNow, metricTypes);
      metricData.forEach(({
         type,
         padding,
         element,
         label = '',
      }) => {
         let val = timeRemaining[`${type}s`];
         if (!showDecimals || showDecimals === 'false') {
            val = Math.floor(val);
         }
         val = Math.max(val, 0);
         if (padDigits) {
            val = val.toString().padStart(padding, '0');
         }
         // skip dom operations if no update necessary
         if (lastValues[type] === val) {
            return;
         }
         let html = `<${wrapElementType} class="${metricValueClass}">${
            val
         }</${wrapElementType}>`;
         if (label) {
            html = html.concat(
               `<${wrapElementType} class="${metricLabelClass}">${
                  val === 1 ? label : label + 's' 
               }<${wrapElementType}>`,
            );
         }
         lastValues[type] = val;
         element.innerHTML = html;
      });
   };
};

export function setupCountdownEvents(){
   if (!Array.isArray(window.evtxCounters)){
      return;
   }
   evtxCounters.forEach(function(c) {
      const countdownElement = document.getElementById(c.countdownId);
      if (!countdownElement) {
         console.warn('Could not find countdown element ID', c.countdownId);
         return;
      }
      const renderFn = makeRenderCountdown(c, countdownElement);
      renderFn();
      countdownElement.classList.add('ready');
      window.setInterval(renderFn, c.refreshInterval);
   });
}
